<script lang="ts">
    import dockBottomIcon from "../assets/dock-bottom.svg?raw";
    import dockRigthIcon from "../assets/dock-right.svg?raw";
    import {
        libraryLayout,
        LibraryLayouts,
        changeDesktopLayout,
    } from "./Library";
</script>

<div
    class="library-controls padding-5px padding-right-5px"
>
    {#if $libraryLayout === LibraryLayouts.DockedBottom}
        <button
            class="library-control-button blue"
            on:click={() => changeDesktopLayout(LibraryLayouts.DockedRight)}
        >
            {@html dockRigthIcon}
        </button>
    {:else if $libraryLayout === LibraryLayouts.DockedRight}
        <button
            class="library-control-button blue"
            on:click={() => changeDesktopLayout(LibraryLayouts.DockedBottom)}
        >
            {@html dockBottomIcon}
        </button>
    {/if}
</div>
